import styles from './index.less';
import ClickEnter from '../../assets/clickEnter.png';
import $ from 'jquery';

const defaultData = {
  bg_color: { r: 0, g: 0, b: 0, a: 0.65 },
  bg_img: '',
  time: 5,
  type: 1,
  repeat: 1,
};
export default class OpenCover {
  constructor(props) {
    this.wrapper = props.wrapper;
    this.props = {
      ...defaultData,
      ...props,
    };
    this.visible = true;
    if (!this.props.url) return;
    this._init();
  }

  _init() {
    this._render();
    this._autoHide();
  }

  _render() {
    const props = this.props;
    this.dom = document.createElement('div');
    this.dom.classList.add(styles['opencover-wrapper']);
    this.dom.style.background = `rgba(${props.bg_color.r},${props.bg_color.g},${props.bg_color.b},${
      props.bg_color.a
    }) url(${props.bg_img}) ${props.repeat == 1 ? 'repeat' : 'no-repeat'} center`;

    let html = `<img class="${styles['opencover-img']}" src="${props.url}"/>`;
    if (props.type === 2) {
      this.dom.addEventListener('click', ev => {
        ev.stopPropagation();
        this.hide();
      });
      html += `<span class="${styles['opencover-open']}" style="background-image:url(${ClickEnter})"></span>`;
    }

    this.dom.innerHTML = html;
    this.wrapper.appendChild(this.dom);
  }

  _autoHide() {
    if (this.props.type === 1) {
      let time = this.props.time;
      this._addTimer(time);
      // let time = this.props.time;
      // setTimeout(() => {
      //   if (this.visible) {
      //     this.hide();
      //   }
      //   time--;
      //   this.$timer.find('span').html(time);
      // }, Number(this.props.time) * 1000);

      this.timer = setInterval(() => {
        time--;
        this.$timer.find('span').html(time);
        if (time <= 0) {
          clearInterval(this.timer);
          if (this.visible) {
            this.hide();
          }
        }
      }, 1000);
    }
  }

  _addTimer(time) {
    if (this.props.type === 1) {
      this.$timer = $(`<span class="${styles.timer}"><span>${time}</span>s后进入</span>`);
      $(this.dom).append(this.$timer);
    }
  }
  show() {
    this.dom.classList.remove(styles['hide']);
    this.visible = true;
  }

  hide() {
    if (!this.visible) return;
    this.dom.classList.add(styles['hide']);
    this.visible = false;
  }
}
